import React, { useContext, useEffect, useState } from 'react';
import TenorContext from '../../context/TenorContext';
import { TenorResult } from '../../managers/TenorManager';
import GifList from './GifList';

export interface SearchResultProps {
	searchTerm: string;
	columnsCount: number;
	params?: any;
}

function SearchResult({ searchTerm, columnsCount, params }: SearchResultProps) {
	const [searchResult, setSearchResult] = useState<TenorResult>(null!);
	const [isLoading, setLoading] = useState(true);
	const [pos, setPos] = useState<string | undefined>(undefined);
	const tenor = useContext(TenorContext);

	useEffect(() => {
		setLoading(true);
		async function search(): Promise<any> {
			const result = await tenor.search(searchTerm, 50, pos, params);
			setSearchResult(result);
			setLoading(false);
		}
		const debounce = setTimeout(() => search(), 800);
		return (): void => clearTimeout(debounce);
	}, [searchTerm, params, pos]);

	return (
		<GifList
			isLoading={isLoading}
			columnsCount={columnsCount}
			result={searchResult}
			searchTerm={searchTerm}
			onLoadMore={() => {
				setPos(searchResult.next);
			}}
		/>
	);
}

export default SearchResult;
